import * as swcHelpers from '@swc/helpers';
import { connectStateResults } from 'react-instantsearch-core';
import { clickedObjectIdsAfterSearch, clickedObjectIds } from './AlgoliaAnalyticsHelpers.js';
import { AlgoliaAnalyticsEvents } from './types.js';
import { useAlgoliaAnalytics } from './useAlgoliaAnalytics.js';

const AlgoliaAnalytics = ({ children , searchResults  })=>{
    if (!children) {
        return null;
    }
    const { saveData  } = useAlgoliaAnalytics();
    const { queryID , index  } = searchResults;
    const handleSearchAnalytics = (objectId, position, eventName)=>()=>{
            const eventData = {
                eventName: eventName || AlgoliaAnalyticsEvents.SearchResultClicked,
                objectIds: objectId,
                searchIndex: index
            };
            if (queryID && position) {
                saveData({
                    queryId: queryID,
                    searchIndex: index
                });
                clickedObjectIdsAfterSearch(swcHelpers.objectSpread({}, eventData, {
                    queryId: queryID,
                    positions: position
                }));
            } else {
                clickedObjectIds(eventData);
            }
        }
    ;
    return children(handleSearchAnalytics);
};
var AlgoliaAnalytics$1 = connectStateResults(AlgoliaAnalytics);

export { AlgoliaAnalytics, AlgoliaAnalytics$1 as default };
//# sourceMappingURL=AlgoliaAnalytics.js.map
